export enum RequestTypeFilter {
    MyRequests = 'my-requests',
    ManagedRequests = 'managed-requests'
}